import {useContext, useState} from 'react'
import OverlayComponent from '../../../../_metronic/layout/components/Popover'
import GlobalMemberActionsDropdown from '../actionsDropdowns/GlobalMemberActionsDropdown'
import {ConfirmationModal} from '../../../../components/ConfirmationModal'
import {ProjectsMembersPageContext} from '../../context'
import {GlobalMemberActionsOverlayTypes} from '../../interfaces'

const GlobalMemberActionsOverlay = ({memberData}: GlobalMemberActionsOverlayTypes) => {
  const {
    removeGlobalProjectMember,
    isLoadingGlobalProjectsMembersOperation,
    isLoadingGlobalProjectsMembersList,
  } = useContext(ProjectsMembersPageContext)
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const onRemove = async (memberId: any) => {
    await removeGlobalProjectMember(memberId)
  }

  return (
    <>
      <OverlayComponent
        btnIcon={<i className='las la-ellipsis-h fs-2x'></i>}
        children={<GlobalMemberActionsDropdown setShowDeleteModal={setShowDeleteModal} />}
      />

      {showDeleteModal && (
        <>
          <ConfirmationModal
            uniqueID={memberData?.username}
            show={showDeleteModal}
            onClose={() => setShowDeleteModal(false)}
            onAction={onRemove}
            isOperationLoading={isLoadingGlobalProjectsMembersOperation}
            isDataLoading={isLoadingGlobalProjectsMembersList}
            body={
              <p>
                Do you really want to remove '<strong>{memberData?.name}</strong>' from global
                project members?
              </p>
            }
          />
        </>
      )}
    </>
  )
}

export default GlobalMemberActionsOverlay
